import React, {useEffect} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../hooks/redux';

import {removeMessage} from "../slices/messageQueueSlice";
import {RootState} from "../types";

export default function(props: any) {
    const messageQueue = useSelector((state: RootState) => state.messageQueue);
    const dispatch = useAppDispatch();

    const onCancel = (id: string) => {
        dispatch(removeMessage(id));
    }

    useEffect(() => {
        if (messageQueue.length) {
            const interval = setInterval(() => {
                dispatch(removeMessage(messageQueue[0].id))
            }, messageQueue[0].duration)

            return () => {clearInterval(interval)}
        }
    }, [messageQueue])

    const assignIcon = (iconType: string) => {
        switch (iconType) {
            case "add" :
                return <Icon.PlusSquare />
            case "remove" :
                return <Icon.XSquare />
            case "edit" :
                return <Icon.Save />
            case "info" :
                return <Icon.Info />
            default:
                return <Icon.AlertCircle />
        }
    }

    return (
        <div className='message-container'>
            {messageQueue.map((toast) =>
                <div className="messager" key={toast.id}>
                    <div className='messager-header'>
                        {assignIcon(toast.icon)}
                        <div>{toast.title}</div>
                        <div onClick={() => onCancel(toast.id)}><Icon.X /></div>
                    </div>
                    <div className='messager-body'><ul><li>{toast.text}</li></ul></div>
                </div>
            )}
        </div>

    );
}
